/* ============================================================
   Pecola Naturals — scroll reveal + stat count-up (mockup).
   Runs only when html.pn-anim is set (motion OK + IO supported).
   Content is always visible if JS is off or reduce-motion is on.
   ============================================================ */
(function () {
  var docEl = document.documentElement;
  if (!docEl.classList.contains('pn-anim')) return;

  var SEL = [
    '.pn-hero__title', '.pn-hero__arc', '.pn-hero__copy p', '.pn-hero__cta', '.pn-hero__media',
    '.pn-statement__title', '.pn-statement .pn-lead',
    '.pn-head', '.pn-pack', '.pn-packs__nav',
    '.pn-why__title', '.pn-why__lead', '.pn-why__photos', '.pn-benefit',
    '.pn-strip__inner', '.pn-stats__card', '.pn-stats__media',
    '.pn-reviews__marquee', '.pn-contact__grid',
    '.pn-footer__brand', '.pn-footer__col', '.pn-footer__bottom'
  ].join(',');

  var els = [].slice.call(document.querySelectorAll(SEL));

  /* Stagger siblings sharing a parent. */
  var pmap = new WeakMap();
  els.forEach(function (el) {
    var p = el.parentNode;
    var i = pmap.get(p) || 0;
    el.style.setProperty('--pn-delay', (Math.min(i, 8) * 90) + 'ms');
    pmap.set(p, i + 1);
  });

  function show(el) { el.classList.add('pn-in'); }

  if (!('IntersectionObserver' in window)) { els.forEach(show); return; }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) { show(entries[i].target); io.unobserve(entries[i].target); }
    }
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

  els.forEach(function (el) { io.observe(el); });

  /* Safety net: reveal everything after 4s no matter what. */
  setTimeout(function () { els.forEach(show); }, 4000);

  /* Count-up on stat numbers. */
  if ('requestAnimationFrame' in window) {
    var nums = [].slice.call(document.querySelectorAll('.pn-stats__num strong'));
    if (nums.length) {
      var nio = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { nio.unobserve(entries[i].target); countUp(entries[i].target); }
        }
      }, { threshold: 0.6 });
      nums.forEach(function (el) { nio.observe(el); });
    }
  }

  function countUp(el) {
    var raw = (el.textContent || '').trim();
    var m = raw.match(/[0-9]+(\.[0-9]+)?/);
    if (!m) return;
    var numStr = m[0];
    var target = parseFloat(numStr);
    var dec = numStr.indexOf('.') >= 0 ? numStr.split('.')[1].length : 0;
    var pre = raw.slice(0, m.index);
    var suf = raw.slice(m.index + numStr.length);
    var dur = 1500, t0 = null;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var pr = Math.min((ts - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - pr, 3);
      el.textContent = pre + (target * eased).toFixed(dec) + suf;
      if (pr < 1) requestAnimationFrame(step);
      else el.textContent = pre + numStr + suf;
    }
    requestAnimationFrame(step);
  }
})();
